import { render, staticRenderFns } from "./roles-in-the-county-district-court.vue?vue&type=template&id=a0fec6f2&"
import script from "./roles-in-the-county-district-court.vue?vue&type=script&lang=js&"
export * from "./roles-in-the-county-district-court.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports